import React from "react";
import {
  Button,
  Dialog,
  DialogProps,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  makeStyles,
  Theme,
  createStyles,
} from "@material-ui/core";

/** スタイル定義 */
const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    content: {
      fontSize: "0.875rem",
      color: theme.palette.text.primary,
    },
  })
);

interface Props {
  open: boolean;
  handleClose: () => void;
  scroll: DialogProps["scroll"];
  title: React.ReactNode | string;
  subtitle?: React.ReactNode;
  content: React.ReactNode | string;
}

/** スクロールダイアログ */
export function ScrollDialog(props: Props) {
  const classes = useStyles();

  //------------------------------
  // openステート
  // [State]
  const { open } = props;
  // [Handler]
  const { handleClose } = props;

  //------------------------------
  // ダイアログ設定
  // [State]
  const { scroll, title, subtitle, content } = props;

  const descriptionElementRef = React.useRef<HTMLElement>(null);
  React.useEffect(() => {
    let cleanedUp = false;

    if (open && !cleanedUp) {
      const { current: descriptionElement } = descriptionElementRef;
      if (descriptionElement !== null) {
        descriptionElement.focus();
      }
    }

    return function cleanup() {
      cleanedUp = true;
    };
  }, [open]);

  //--------------------
  // コンポーネント
  return (
    <div>
      <Dialog
        open={open}
        onClose={handleClose}
        maxWidth="lg"
        scroll={scroll}
        aria-labelledby="scroll-dialog-title"
        aria-describedby="scroll-dialog-description"
      >
        <DialogTitle id="scroll-dialog-title">{title}</DialogTitle>
        {subtitle && subtitle}
        <DialogContent dividers={scroll === "paper"}>
          <DialogContentText
            id="scroll-dialog-description"
            className={classes.content}
            ref={descriptionElementRef}
            tabIndex={-1}
          >
            {content}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="primary">
            OK
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
